<template>
  <div
    :class="'wrapper ' + cssClass"
    :style="cssStyle"
  >
    <HeaderBar
      v-if="header"
      :title="title"
      :transparent="transparent"
      :back-link="backLink"
    />
    <div :class="['content', {transparent: transparent}]">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Surround',
  props: {
      header: {
        type: Boolean,
        default: true
      },
      surroundColor: {
        type: String,
        default: "black"
      },
      surroundImage: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: ''
      },
      transparent: {
        type: Boolean,
        default: false
      },
      backLink: {
        type: [String, Object, Boolean],
        default: false
      },
  },
  computed: {
      cssClass() {
          return this.header ? 'header' : '';
      },
      cssStyle() {
        const styles = [
          ['background-color', this.surroundColor],
        ]
        if (this.surroundImage) {
          styles.push(...[
            ['background-image', 'url(' + this.surroundImage + ')'],
            ['background-size', 'cover'],
            ['background-position', 'center']
          ])
        }
        let stylestr = ''
        styles.forEach((i) => stylestr += i.join(':') + ';')
        return stylestr
      }
  }
}
</script>

<style lang="scss" scoped>

.wrapper {
    @include flex-vertical;
    // padding: 0 2rem 2rem;
    height: 100%;

    background: black;

    &.header {
        padding-top: 0;
    }
}
.content {
    @include flex-fill-vertical;
    background: white;
    display: flex;
    margin: 2rem;
    &.transparent {
      margin: 0 2rem 2rem;
    }
}
</style>
